import { useContext } from 'react'
import { Droppable } from 'react-beautiful-dnd'
import { useTranslation } from 'react-i18next'
import { Box, Grid, LinearProgress } from '@mui/material'

import { DraggableElement } from '@pages/FormCreateOrEdit/components/FieldsConfig/AvailableElementsOutsideForm/DraggableElement'
import { Title } from '@pages/TooltipCreateOrEdit/components/ConfigFields'

import { FORM_ELEMENT_TYPE_TO_DROPPABLE_TYPE } from '@constants'

import { WindowConfigContext } from './WindowConfig'

export const AvailableSectionElements = () => {
  const { t } = useTranslation()

  const { availableSections, isLoadingWindowById } = useContext(WindowConfigContext)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
      {isLoadingWindowById && (
        <LinearProgress sx={{ position: 'absolute', top: '-1rem', width: '100%' }} />
      )}
      <Grid item>
        <Title sx={{ ml: 2 }} title={t('sectionsConfig.available')} />
      </Grid>
      {availableSections?.map((element, elementIndex) => (
        <Droppable
          key={`${element.id}`}
          isDropDisabled
          droppableId={`${element.type}:${element.id}`}
          type={FORM_ELEMENT_TYPE_TO_DROPPABLE_TYPE[element.type]}
        >
          {provided => (
            <Box ref={provided.innerRef} {...provided.droppableProps}>
              <DraggableElement
                element={element}
                index={elementIndex}
                title={element.title || ''}
              />
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      ))}
    </Box>
  )
}
